// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AlertRuleFormQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  alertRuleId: Types.Scalars["ID"]["input"];
  isEdit: Types.Scalars["Boolean"]["input"];
}>;

export type AlertRuleFormQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    servers: Array<{ __typename?: "Server"; humanId: string; name: string }>;
  } | null;
  getAlertDestinations: Array<{
    __typename?: "AlertDestination";
    id: string;
    name: string;
    memberCount: number;
    integrations: Array<{
      __typename?: "AlertDestinationIntegration";
      id: string;
      kind: string;
      displayName: string;
    }>;
  }>;
  getAlertRuleDetails?: {
    __typename?: "AlertRule";
    id: string;
    name: string;
    checkKinds: Array<string>;
    permittedToDelete: boolean;
    server?: { __typename?: "Server"; humanId: string } | null;
    destinations: Array<{
      __typename?: "AlertDestination";
      id: string;
      name: string;
    }>;
  };
};

export const AlertRuleFormDocument = gql`
  query AlertRuleForm(
    $organizationSlug: ID!
    $alertRuleId: ID!
    $isEdit: Boolean!
  ) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      servers {
        humanId
        name
      }
    }
    getAlertDestinations(organizationSlug: $organizationSlug) {
      id
      name
      memberCount
      integrations {
        id
        kind
        displayName
      }
    }
    getAlertRuleDetails(alertRuleId: $alertRuleId) @include(if: $isEdit) {
      id
      name
      server {
        humanId
      }
      checkKinds
      permittedToDelete
      destinations {
        id
        name
      }
    }
  }
`;

/**
 * __useAlertRuleFormQuery__
 *
 * To run a query within a React component, call `useAlertRuleFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertRuleFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertRuleFormQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      alertRuleId: // value for 'alertRuleId'
 *      isEdit: // value for 'isEdit'
 *   },
 * });
 */
export function useAlertRuleFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertRuleFormQuery,
    AlertRuleFormQueryVariables
  > &
    (
      | { variables: AlertRuleFormQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertRuleFormQuery, AlertRuleFormQueryVariables>(
    AlertRuleFormDocument,
    options,
  );
}
export function useAlertRuleFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertRuleFormQuery,
    AlertRuleFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertRuleFormQuery, AlertRuleFormQueryVariables>(
    AlertRuleFormDocument,
    options,
  );
}
// @ts-ignore
export function useAlertRuleFormSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertRuleFormQuery,
    AlertRuleFormQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertRuleFormQuery,
  AlertRuleFormQueryVariables
>;
export function useAlertRuleFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertRuleFormQuery,
        AlertRuleFormQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertRuleFormQuery | undefined,
  AlertRuleFormQueryVariables
>;
export function useAlertRuleFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertRuleFormQuery,
        AlertRuleFormQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertRuleFormQuery,
    AlertRuleFormQueryVariables
  >(AlertRuleFormDocument, options);
}
export type AlertRuleFormQueryHookResult = ReturnType<
  typeof useAlertRuleFormQuery
>;
export type AlertRuleFormLazyQueryHookResult = ReturnType<
  typeof useAlertRuleFormLazyQuery
>;
export type AlertRuleFormSuspenseQueryHookResult = ReturnType<
  typeof useAlertRuleFormSuspenseQuery
>;
export type AlertRuleFormQueryResult = Apollo.QueryResult<
  AlertRuleFormQuery,
  AlertRuleFormQueryVariables
>;
